import React from "react";
import TimePicker from 'rsuite/TimePicker';

// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import 'rsuite/TimePicker/styles/index.css';

/* this component uses datejs library to format time */
const RSuiteTimePicker = () => {
  return (
    <TimePicker hideMinutes={minute => minute % 15 !== 0} editable={false} appearance="subtle"
                placeholder="Podaj czas"
                placement={`autoVerticalStart`}
    />

);
};

export default RSuiteTimePicker;
